module.exports = __webpack_public_path__ + "static/install-batteries-index-1e68c2aea6ed84aa37c8191b039cfe3a.png";